import { APP_SIZES } from "Common/componentUtils/constants";
import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    TAB_ROTATE_PADDING: "12px 6px 12px 16px",
    TAB_NO_ROTATE_PADDING: "6px 8px"
};
export default {
    SidebarMenuContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["width", "bgColorDefault"], prop)
    }) `
    width: ${({ width }) => (width ? `${width}px` : "auto")};
    height: 100%;
    background-color: ${({ theme, bgColorDefault }) => theme[bgColorDefault]};
    display: grid;
    grid-template-columns: ${APP_SIZES.SIDEBAR_COLLAPSED_WIDTH}px 1fr;
    grid-template-rows: auto 1fr auto;
    position: relative;
    border-right: 1px solid #dfe5ec;
  `,
    SidebarMenuTabsContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["bgColorDefault", "rows"], prop)
    }) `
    z-index: ${({ theme }) => parseInt(theme["zindex-navbar-fixed"]) + 3};
    grid-row: span ${({ rows }) => rows};
    border-right: 1px solid #dfe5ec;
  `
};
